import Qs from 'qs'
import server from './server'

export const getDestinations = (params = {}) => {
  return server.get('/hotel_beds/destinations', {
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, {arrayFormat: 'brackets'})
    },
  })
}
